import React from 'react';
import Loader from '../components/common/Loader';
import StartButton from '../components/home_borin/StartButton';
import Menu from '../components/home_borin/Menu';
import Navbar from '../components/home_borin/Navbar';
import Header from '../components/home_borin/Header';
import About from '../components/home_borin/About';
import Location from '../components/home_borin/Location';
import Footer from '../components/home_borin/Footer';
import { Helmet } from 'react-helmet';
import Experience from '../components/home_borin/Experience';
import Benefits from '../components/home_borin/Benefits';
import Residence from '../components/home_borin/Residence';
import Apartment from '../components/home_borin/Apartment';
import Health from '../components/home_borin/Health';
import SocialClub from '../components/home_borin/SocialClub';
import Creators from '../components/home_borin/Creators';
//import reportWebVitals from '../reportWebVitals';

// Ativar para medir desempenho
//reportWebVitals(console.log);
function Home() {
  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href="/home_borin/assets/css/home_5_style.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/home_borin/assets/js/home_scripts.js"></script>
      </Helmet>
      <body className="home-style5">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <Header />
          <main>
            <About />
            <Experience />
            <Location />
            <Benefits />
            <Residence />
            <Apartment />
            <Health />
            <SocialClub />
            <Creators />
          </main>
          <Footer />
        </div>
        <StartButton />
      </body>
    </>
  );
}

export default Home;
